/* =========================================================
   Zoom + Lightbox enhancement layer (v2)
   - Magnifier lens is delegated ONLY to the main-image
     slider-component (sibling of the thumbnail slider),
     so thumbnails structurally cannot trigger zoom.
   - Lens is appended inside the active image's own wrap
     (which has overflow:hidden), so it can never render
     outside the image or over the product info column.
   - Fancybox lightbox for image media (unchanged behavior).
   Works WITH the theme's existing <media-gallery> / slider /
   thumbnail / variant-switching markup — does not replace it.
   ========================================================= */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('media-gallery').forEach(initMagnifier);
    document.querySelectorAll('[data-zoom-lightbox-media]').forEach(initFancybox);
  });

  /* ---------------- Magnifier zoom (desktop only, main image only) ---------------- */
  function initMagnifier(gallery) {
    const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isFinePointer) return;

    const container = gallery.closest('.product__media_container');
    if (!container) return;

    // The slider that holds ONLY the main image slides — explicitly
    // excludes the thumbnail slider so zoom can never bind to thumbs.
    const mainSlider = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    if (!mainSlider) return;

    const lens = document.createElement('div');
    lens.className = 'zl-lens';

    function getActiveWrap() {
      const activeItem = mainSlider.querySelector('.product__media-item.is-active');
      if (!activeItem) return null;
      return activeItem.querySelector('.product__modal-opener--image .product__media');
    }

    function getActiveImage(wrap) {
      return wrap ? wrap.querySelector('img') : null;
    }

    mainSlider.addEventListener(
      'mouseenter',
      () => {
        const wrap = getActiveWrap();
        const img = getActiveImage(wrap);
        if (!wrap || !img) return;
        if (lens.parentElement !== wrap) wrap.appendChild(lens);
        container.classList.add('is-zooming');
      },
      true
    );

    mainSlider.addEventListener(
      'mouseleave',
      () => {
        container.classList.remove('is-zooming');
      },
      true
    );

    mainSlider.addEventListener(
      'mousemove',
      (e) => {
        const wrap = getActiveWrap();
        const img = getActiveImage(wrap);
        if (!wrap || !img) {
          container.classList.remove('is-zooming');
          return;
        }
        if (lens.parentElement !== wrap) wrap.appendChild(lens);

        const rect = wrap.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Outside the actual image bounds (e.g. cursor moved onto
        // surrounding chrome) — hide the lens, never render it elsewhere.
        if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
          container.classList.remove('is-zooming');
          return;
        }
        container.classList.add('is-zooming');

        const lensSize = Math.max(Math.min(rect.width, rect.height) * 0.32, 90);
        let lensX = x - lensSize / 2;
        let lensY = y - lensSize / 2;
        lensX = Math.max(0, Math.min(lensX, rect.width - lensSize));
        lensY = Math.max(0, Math.min(lensY, rect.height - lensSize));

        lens.style.width = `${lensSize}px`;
        lens.style.height = `${lensSize}px`;
        lens.style.left = `${lensX}px`;
        lens.style.top = `${lensY}px`;

        const zoomFactor = 2.5;
        const bgSrc = img.currentSrc || img.src;
        const bgUrl = `url("${bgSrc}")`;
        if (lens.style.backgroundImage !== bgUrl) {
          lens.style.backgroundImage = bgUrl;
        }
        lens.style.backgroundSize = `${rect.width * zoomFactor}px ${rect.height * zoomFactor}px`;
        // Center of the lens (in container coords) maps to the center of
        // the lens box in the scaled background — this is what makes the
        // zoomed content line up with the cursor instead of drifting.
        const lensCenterX = lensX + lensSize / 2;
        const lensCenterY = lensY + lensSize / 2;
        const bgPosX = lensSize / 2 - lensCenterX * zoomFactor;
        const bgPosY = lensSize / 2 - lensCenterY * zoomFactor;
        lens.style.backgroundPosition = `${bgPosX}px ${bgPosY}px`;
      },
      true
    );
  }

  /* ---------------- Fancybox lightbox ---------------- */
  function initFancybox(script) {
    let mediaList;
    try {
      mediaList = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    if (!mediaList || !mediaList.length) return;

    const sectionId = script.dataset.zoomLightboxMedia;
    const container = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!container) return;

    container.addEventListener(
      'click',
      (e) => {
        const opener = e.target.closest('.product__modal-opener--image');
        if (!opener) return;
        if (!window.Fancybox) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const mediaIdBtn = opener.querySelector('[data-media-id]');
        const mediaId = mediaIdBtn ? mediaIdBtn.dataset.mediaId : null;
        let startIndex = mediaList.findIndex((m) => String(m.id) === String(mediaId));
        if (startIndex < 0) startIndex = 0;

        window.Fancybox.show(
          mediaList.map((m) => ({ src: m.src, type: 'image', caption: m.alt || '' })),
          {
            startIndex,
            Keyboard: { Escape: true, Backspace: true, PageUp: true, PageDown: true },
            Toolbar: { display: ['zoom', 'slideshow', 'thumbs', 'close'] },
            Thumbs: { showOnStart: true },
            Image: { zoom: true },
            touch: { vertical: true, momentum: true },
          }
        );
      },
      true
    );
  }
})();
